export class UsuarioModel {
    id: Number
    cpf: String
    name: String
    email: String
    usuarioNovo: false
    foto: String
    formulario_trader: boolean
    admin: boolean
    aai: boolean
}